import { Component } from '@angular/core';
import { RouterOutlet } from "@angular/router";
import { Amplify } from 'aws-amplify';
import outputs from '../../amplify_outputs.json';
import { environment } from "../environments/environment";
import { CookieConsentBannerComponent } from './shared/cookie-consent-banner/cookie-consent-banner.component';

Amplify.configure(outputs);

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  imports: [RouterOutlet, CookieConsentBannerComponent]
})
export class AppComponent {
  readonly version = environment.appVersion as string;

  constructor() {
    console.log(`App version: ${this.version}`);
  }
}
